export const LOGIN = "LOGIN";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
// Get user details from application storage
export const GET_USER = "GET_USER";
// Get account details from application storage
export const GET_ACCOUNT = "GET_ACCOUNT";
// Install App and open/disallow registration page
export const SHOPIFY_INSTALL_APP = "SHOPIFY_INSTALL_APP";
export const CHECK_REGISTER_PAGE = "CHECK_REGISTER_PAGE";
// Register Account and user
export const REGISTER = "REGISTER";
// Get Pending Orders data
export const GET_PENDING_ORDERS = "GET_PENDING_ORDERS";
export const STORE_LOADER = "STORE_LOADER";
// Filter orders via customers on dashboard screen
export const CUSTOMER_FILTER = "CUSTOMER_FILTER";
// Filter orders via company on dashboard screen
export const COMPANY_FILTER = "COMPANY_FILTER";
// Filter orders via status on dashboard screen
export const STATUS_FILTER = "STATUS_FILTER";
// Filter orders via from date and to date on dashboard screen
export const DATE_FILTER = "DATE_FILTER";
// Get Customers data
export const GET_CUSTOMER_DETAILS = "GET_CUSTOMER_DETAILS";

//save new card and charege customer
export const PAYMENT_AFTER_CARD_VALIDATION = "PAYMENT_AFTER_CARD_VALIDATION";

//save new card and charege customer
export const MULTIPLE_PAYMENT_AFTER_CARD_VALIDATION = "MULTIPLE_PAYMENT_AFTER_CARD_VALIDATION";
//get saved cards list
export const PAYMENT_CARD_LIST = "PAYMENT_CARD_LIST";
//get multiple saved cards list
export const MULTIPLE_PAYMENT_CARD_LIST = "MULTIPLE_PAYMENT_CARD_LIST";
//pay with save card
export const PAYMENT_WITH_SAVED_CARD = "PAYMENT_WITH_SAVED_CARD";
//Multiple pay with save card
export const MULTIPLE_PAYMENT_WITH_SAVED_CARD = "MULTIPLE_PAYMENT_WITH_SAVED_CARD";
// Store order data
export const STORE_ORDER = "STORE_ORDER";
// Select payment term by Handling tags
export const SELECT_PAYMENT_TERM = "SELECT_PAYMENT_TERM";
// Update order data
export const UPDATE_ORDER = "UPDATE_ORDER";
// Delete order data
export const DELETE_ORDER = "DELETE_ORDER";
// Store multiple order data
export const ENABLE_MULTIPLE_ORDERS = "ENABLE_MULTIPLE_ORDERS";
// Delete Multiple order data
export const DELETE_MULTIPLE_ORDERS = "DELETE_MULTIPLE_ORDERS";
// Get email cadence for an order
export const GET_EMAIL_CADENCE_FOR_ORDER = "GET_EMAIL_CADENCE_FOR_ORDER";
// Resend Invoice
export const RESEND_INVOICE = "RESEND_INVOICE";
export const RESEND_STATEMENT = "RESEND_STATEMENT";
// Get Plans
export const GET_PLANS = "GET_PLANS";
// Subscribe a Plan
export const SUBSCRIBE_PLAN = "SUBSCRIBE_PLAN";
// Update user and plan
export const UPDATE_USER = "UPDATE_USER";
// Verify Reset Password Token
export const VERIFY_TOKEN = "VERIFY_TOKEN";
// Reset Password
export const RESET_PASSWORD = "RESET_PASSWORD";
// Verify Subdomain
export const VERIFY_SUBDOMAIN = "VERIFY_SUBDOMAIN";
// Download Invoice
export const DOWNLOAD_INVOICE = "DOWNLOAD_INVOICE";
// Download customer Invoice
export const DOWNLOAD_CUSTOMER_INVOICE = "DOWNLOAD_CUSTOMER_INVOICE";
// Orders manipulated
export const ORDERS_MANIPULATED = "ORDERS_MANIPULATED";
// Get remaining orders allowed to be enable details
export const GET_REMAINING_ORDERS_ALLOWED_TO_ENABLE = "GET_REMAINING_ORDERS_ALLOWED_TO_ENABLE";
// Onboarding completed by user
export const ONBOARDING_VERIFIED = "ONBOARDING_VERIFIED";
// Check Webhooks
export const CHECK_WEBHOOKS = "CHECK_WEBHOOKS";
// Check Shop Registration
export const CHECK_SHOP_REGISTRATION = "CHECK_SHOP_REGISTRATION";
// Check Stripe connection
export const CHECK_STRIPE_CONNECTION = "CHECK_STRIPE_CONNECTION";
// Check Customer Checkout
export const CUSTOMER_CHECKOUT = "CUSTOMER_CHECKOUT";

export const MULTIPLE_CUSTOMER_CHECKOUT = "MULTIPLE_CUSTOMER_CHECKOUT";

export const MARK_MULTIPLE_ORDERS_AS_PAID = "MARK_MULTIPLE_ORDERS_AS_PAID";
// Marking order as paid
export const MARK_ORDER_AS_PAID = "MARK_ORDER_AS_PAID";
// Associate shop owner's stripe account after redirection from stripe page
export const ASSOCIATE_STRIPE_ACCOUNT = "ASSOCIATE_STRIPE_ACCOUNT";
// Get Account Details
export const GET_ACCOUNT_DETAILS = "GET_ACCOUNT_DETAILS";
// Update Account Details
export const UPDATE_ACCOUNT_DETAILS = "UPDATE_ACCOUNT_DETAILS";
// Enable Send invoice on pending order creation setting
export const ENABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING =
  "ENABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING";
// Disable Send invoice on pending order creation setting
export const DISABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING =
  "DISABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING";
// Save Logo
export const SAVE_LOGO = "SAVE_LOGO";
export const SAVE_EMAIL_SETTINGS = "SAVE_EMAIL_SETTINGS";
export const FETCH_EMAIL_SETTINGS = "FETCH_EMAIL_SETTINGS";

//Fetch PDF settings
export const SAVE_PDF_EMAIL_SETTINGS = "SAVE_PDF_EMAIL_SETTINGS";
export const FETCH_PDF_SETTINGS = "FETCH_PDF_SETTINGS";
// Remove Logo
export const REMOVE_LOGO = "REMOVE_LOGO";
// Calculate net payment days from fulfillment date setting
export const CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING =
  "CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING";
// Remove calculate net payment days from fulfillment date setting
export const REMOVE_CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING =
  "REMOVE_CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING";
export const GET_ACCEPT_NEW_SCOPE_AUTH_URL = "GET_ACCEPT_NEW_SCOPE_AUTH_URL";
export const NEW_SCOPES_ACCEPTED = "NEW_SCOPES_ACCEPTED";
export const ADD_CUSTOM_NET_TERMS_MUTATION = "ADD_CUSTOM_NET_TERMS_MUTATION";
export const REMOVE_CUSTOM_NET_TERMS_MUTATION = "REMOVE_CUSTOM_NET_TERMS_MUTATION";
export const ENABLE_CUSTOM_NET_TERMS_SETTING = "ENABLE_CUSTOM_NET_TERMS_SETTING";
export const DISABLE_CUSTOM_NET_TERMS_SETTING = "DISABLE_CUSTOM_NET_TERMS_SETTING";
// Add/Remove custom net term
export const ADD_CUSTOM_NET_TERM = "ADD_CUSTOM_NET_TERM";
export const REMOVE_CUSTOM_NET_TERM = "REMOVE_CUSTOM_NET_TERM";
// Multiple email address
export const ADD_EMAIL_MULTIPLE_EMAIL_ADDRESS = "ADD_EMAIL_MULTIPLE_EMAIL_ADDRESS";
export const REMOVE_EMAIL_MULTIPLE_EMAIL_ADDRESS = "REMOVE_EMAIL_MULTIPLE_EMAIL_ADDRESS";
export const ENABLE_DISABLE_EMAIL_MULTIPLE_EMAIL_ADDRESS = "ENABLE_DISABLE_EMAIL_MULTIPLE_EMAIL_ADDRESS";
export const GET_ACCOUNT_DETAILS_FOR_CUSTOMER_CHECKOUT = "GET_ACCOUNT_DETAILS_FOR_CUSTOMER_CHECKOUT";
export const STATEMENT_FOR_CUSTOMERS = "STATEMENT_FOR_CUSTOMERS";
export const REMOVE_STATEMENT_FOR_CUSTOMERS = "REMOVE_STATEMENT_FOR_CUSTOMERS";
export const UPDATE_STATEMENT_DAYS = "UPDATE_STATEMENT_DAYS";
// Periodic Updates
export const ADD_PERIODIC_UPDATES = "ADD_PERIODIC_UPDATES";
export const REMOVE_PERIODIC_UPDATES = "REMOVE_PERIODIC_UPDATES";
// Delete stripe connection
export const DELETE_STRIPE_CONNECTION = "DELETE_STRIPE_CONNECTION";
// Order preview
export const GET_ORDER_REMINDER_EMAIL_PREVIEW = "GET_ORDER_REMINDER_EMAIL_PREVIEW";
export const GET_ORDER_STATEMENT_REMINDER_EMAIL_PREVIEW = "GET_ORDER_STATEMENT_REMINDER_EMAIL_PREVIEW";
// Billing email addresses
export const GET_BILLING_ADDRESSES_OF_CUSTOMER = "GET_BILLING_ADDRESSES_OF_CUSTOMER";
export const ADD_BILLING_ADDRESS_FOR_CUSTOMER = "ADD_BILLING_ADDRESS_FOR_CUSTOMER";
export const DELETE_BILLING_ADDRESS_OF_CUSTOMER = "DELETE_BILLING_ADDRESS_OF_CUSTOMER";
// Customer screen requests
export const CUSTOMER_SCREEN_CREATE_REQUEST = "CUSTOMER_SCREEN_CREATE_REQUEST";
export const CUSTOMER_SCREEN_REQUEST_STATUS = "CUSTOMER_SCREEN_REQUEST_STATUS";
export const CUSTOMER_SCREEN_DEACTIVATE_REQUEST = "CUSTOMER_SCREEN_DEACTIVATE_REQUEST";
//SendStripeLinkInEmail
export const ENABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL = "ENABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL";
export const DISABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL = "DISABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL";
//SendShopifyCheckoutLinkInEmail
export const ENABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL = "ENABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL";
export const DISABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL =
  "DISABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL";
export const GET_PLANS_PRICES = "GET_PLANS_PRICES";
